/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-07-25.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-07-25.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-07-25.mdx';

const metadata = {
  slug: "2020-07-25",
  title: "Life Philosophy: -1 < 0 < 1",
  author: "Christian Battaglia",
  description: "My new life philosophy mirrors the prisoner's dilemma — start every day at zero, can't go negative. A mental model where cooperation always wins and every day is net positive by design.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-07-25T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["philosophy","game theory","prisoner's dilemma","happiness","life lessons","personal growth","life philosophy","decision making"],
};

export const Route = createFileRoute('/blog/posts/2020-07-25')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-07-25',
    image: '/og/blog/2020-07-25.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
